export default __webpack_public_path__ + "static/media/gocd.301ea5b8.svg";